/* 재고 관리 */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useMaterial } from '../../stores/material/material/MaterialAction';
import { useMaterialIn } from '../../stores/material/materialIn/MaterialInAction';
import { useMaterialOut } from '../../stores/material/materialOut/MaterialOutAction';
import { useMaterialAPI } from '../../api/material/useMaterialAPI';

import Search from '../../components/Search/Search';
import CrudModal from '../../components/Modal/Crud/CrudModal';
import Table from '../../components/Table/Table/Table';
import BaseModal from '../../components/Modal/Base/BaseModal';
import ExcelImportResultModal from '../../components/Modal/ExcelImportResult/ExcelImportResultModal';
import { materialTableColumns, materialInColumns, materialOutColumns,
  materialFormFields, materialInFormFields, materialOutFormFields, materialSearchFormFields
} from './context';

import './MaterialManagement.css';
import { FaBoxes } from 'react-icons/fa';


const MaterialManagement = () => {

  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const material = useSelector((state) => state.material);
  const materialIn = useSelector((state) => state.materialIn);
  const materialOut = useSelector((state) => state.materialOut);

  const materialApi = useMaterial();
  const materialInApi = useMaterialIn();
  const materialOutApi = useMaterialOut();
  const materialDirectApi = useMaterialAPI();

  const [isLoading, setIsLoading] = useState(true);

  const [clickedRow, setClickedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState(null)
  const [content, setContent] = useState(null);
  const [importResult, setImportResult] = useState(null);
  const [importResultOpen, setImportResultOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  // type : 1 = 등록, 2 = 수정
  // category : 1 = 자재, 2 = 입고, 3 = 출고
  const openModal = (type, category, row = null) => {
    let action;
    let formFields
    if(category === 1){
      formFields = materialFormFields;
      if(type === 1){
        setModalTitle(<><FaBoxes style={{ marginRight: '8px' }} /> 자재 등록</>)
        action = addMaterial;
      } else {
        setModalTitle(<><FaBoxes style={{ marginRight: '8px' }} /> 자재 수정</>)
        action = updateMaterial;
      }
    } else if (category === 2){
      formFields = materialInFormFields
      if(type === 1){
        setModalTitle(<><FaBoxes style={{ marginRight: '8px' }} /> 입고 등록</>)
        action = addMaterialIn;
      } else{
        setModalTitle(<><FaBoxes style={{ marginRight: '8px' }} /> 입고 수정</>)
        action = updateMaterialIn;
      }
    } else if (category === 3){
      formFields = materialOutFormFields
      if(type === 1){
        setModalTitle(<><FaBoxes style={{ marginRight: '8px' }} /> 출고 등록</>)
        action = addMaterialOut;
      } else{
        setModalTitle(<><FaBoxes style={{ marginRight: '8px' }} /> 출고 수정</>)
        action = updateMaterialOut;
      }
    }
    setIsOpen(true);
    setContent(
    <CrudModal
      type={type}
      formFields={formFields}
      formDatas={row || {}}
      onClose={closeModal}
      onSubmit={action}
    />);
  };

  const searchMaterial = (params = {}) => {
    params.companySeq = session.companySeq;
    dispatch(materialApi.request.get(params));
  }

  const addMaterial = async (data) => {
    data.companySeq = session.companySeq
    await materialApi.request.post(data);
    searchMaterial({ page: currentPage, size: 10 });
  }
  const updateMaterial = async (data) => {
    data.companySeq = session.companySeq
    await materialApi.request.put(data);
    searchMaterial({ page: currentPage, size: 10 });
  };

  const deleteMaterial = async (row) => {
    const params = [row.materialSeq]
    await materialApi.request.delete(params)
    searchMaterial({ page: currentPage, size: 10 });
  }

  const materialPaging = (page) => {
    setCurrentPage(page);
    const parmas = {
      page : page,
      size : 10
    }
    searchMaterial(parmas)
    setClickedRow(null);
  }
  const searchMaterialIn = (params) => {
    dispatch(materialInApi.request.get(params));
  }
  const addMaterialIn = async (data) => {
    data.companySeq = session.companySeq
    data.materialSeq = clickedRow.materialSeq
    await materialInApi.request.post(data);
    searchMaterialIn({
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    });
  }
  const updateMaterialIn = async (data) => {
    data.companySeq = session.companySeq
    data.materialSeq = clickedRow.materialSeq
    await materialInApi.request.put(data);
    searchMaterialIn({
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    });
  };
  const deleteMaterialIn = async (row) => {
    const params = [row.materialInSeq]
    await materialInApi.request.delete(params)
    searchMaterialIn({
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    });
  }
  
  const searchMaterialOut = (params) => {
    dispatch(materialOutApi.request.get(params));
  }

  const addMaterialOut = async (data) => {
    data.companySeq = session.companySeq
    data.materialSeq = clickedRow.materialSeq
    await materialOutApi.request.post(data);
    searchMaterialOut({
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    });
  }

  const updateMaterialOut = async (data) => {
    data.companySeq = session.companySeq
    data.materialSeq = clickedRow.materialSeq
    await materialOutApi.request.put(data);
    searchMaterialOut({
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    });
  };
  const deleteMaterialOut = async (row) => {
    const params = [row.materialOutSeq]
    await materialOutApi.request.delete(params)
    searchMaterialOut({
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    });
  }

  const handleMaterialRowClick = async (row) => {
    if (!row.materialSeq) {
      console.error('Invalid material row:', row);
      return;
    }
    if (clickedRow && clickedRow.materialSeq === row.materialSeq) {
      setClickedRow(null);
      return;
    }
      setClickedRow(row)
  };

  useEffect(() => {
    try {
      const params = {
        companySeq: session.companySeq,
        page: 1,
        size: 10
      };
      searchMaterial(params);
    } catch (error) {
      console.error('Error fetching Material : ', error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, session]);

  useEffect(() => {
    if(!clickedRow) return;
    const params = {
      companySeq: session.companySeq,
      materialSeq: clickedRow.materialSeq
    };
    try {
      searchMaterialIn(params);
      searchMaterialOut(params);
    } catch (error) {
      console.error('Error fetching Material Sub data:', error);
    }
  }, [clickedRow]);

  const handleExcelDownload = async () => {
    await materialDirectApi.material.download({ companySeq: session.companySeq });
  };

  const handleExcelUpload = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async () => {
      const files = Array.from(input.files || []);
      if (files.length === 0) return;
      const formData = new FormData();
      formData.append('file', files[0]);
      try {
        const result = await materialDirectApi.material.import(formData);
        if (result && result.data) {
          setImportResult(result.data);
          setImportResultOpen(true);
        }
        searchMaterial({ page: currentPage, size: 10 });
      } catch (e) {
        alert('엑셀 업로드 실패');
      }
    };
    input.click();
  };

  const closeModal = () => {
    setIsOpen(false);
  };


  return (
    <div className="inventory-management">
      <div className="inventory-table-container">
        <Search
          search={searchMaterial}
          formFields={materialSearchFormFields}
        />

        <Table
          title={ <><FaBoxes style={{ marginRight: '8px' }} /> 자재 목록 </> }
          className="inventory-table"
          columns={materialTableColumns(openModal, deleteMaterial, updateMaterial)} 
          data={material.data}
          page={material.page}
          onRowClick={handleMaterialRowClick}
          onAddClick={() => openModal(1, 1)}
          paging={materialPaging}
          showSearchBar={false}
          excelExport={handleExcelDownload}
          excelImport={handleExcelUpload}
        />
      </div>

      {clickedRow && (
      <div className="bottom-tables-container">
        <div className="left-table">
          <Table
            title={ <><FaBoxes style={{ marginRight: '8px' }} /> 입고 목록 </> }
            className="incoming-inventory-table"
            columns={materialInColumns(openModal, deleteMaterialIn)} 
            data={materialIn.data}
            onAddClick={ () => openModal(1, 2) }
            showSearchBar={false}
          />
        </div>
        <div className="right-table">
          <Table
            title={ <><FaBoxes style={{ marginRight: '8px' }} /> 출고 목록 </> }
            className="outgoing-inventory-table"
            columns={materialOutColumns(openModal, deleteMaterialOut)} 
            data={materialOut.data} 
            onAddClick={() => openModal(1, 3)}
            showSearchBar={false}
          />
        </div>  
      </div>
      )}
      <BaseModal
        children={content}
        title={modalTitle}
        isOpen={isOpen}
        onClose={closeModal}
      />
      <ExcelImportResultModal
        isOpen={importResultOpen}
        onClose={() => setImportResultOpen(false)}
        result={importResult}
      />
    </div>
  );
};

export default MaterialManagement;